/* eslint-disable */
import axios from 'axios'
import ElementUI from 'element-ui';
import resetMessage from '../assets/js/resetMessage';
import router from '../router'
import 'element-ui/lib/theme-chalk/index.css';
let appCode = 'XYGL'
// let appCode = 'JCSJGL'

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 88888888; // 请求超时时间
export const ERR_OK = '0'; // 请求成功返回状态，字段和后台统一
export const ERR_RELOGIN = 401; //重新登录状态
export const BASE_URL = process.env.BASE_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const HOST_URL = process.env.HOST_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const token = localStorage.getItem("token")
// 请求超时时间
axios.defaults.timeout = TIME_OUT
let loadingInstance;
// 封装请求拦截
axios.interceptors.request.use(
	config => {
		loadingInstance = ElementUI.Loading.service({ fullscreen: true });
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
axios.interceptors.response.use(
	response => {
		//拦截器状态
		loadingInstance.close();
		if (response.data.code == '90007') {
			// resetMessage({
			// 	message: '登录已失效，请重新登录！',
			// });
			localStorage.clear()
			sessionStorage.clear()
			 //router.replace({
			 //	path: '/user/login'
			 //})

      // 修改部署
      // let urls = 'http://localhost:8600/web'
			// let urls = 'http://beta.welaiedu.cn/#/'
			let urls = 'http://www.welaiedu.cn/#/'
			// let urls = 'http://sso.welaiedu.cn/#/user/login'
			// let urls = 'http://beta.sso.welaiedu.cn/#/user/login'
			 window.open(urls, '_self')
			return false
		} else if (response.data.code == '0' || response.data.code == '200' || response.data.code == '201') {
			Interceptor(response.data.code)
			return response;
		} else {
			ElementUI.Message({
				message: response.data.msg,
			});
			return false
		}
	},
	error => {
		loadingInstance.close();
		// resetMessage({
		// 	message: '请求失败',
		// });
		return false
		// if(error.response) {
		//  //拦截器状态
		//  Interceptor(error.response.status)
		// }
		// // 返回接口返回的错误信息
		// return Promise.reject(error.response.data)
	});

//拦截器状态
function Interceptor(i) {
	switch (i) {
		case 401:
			localStorage.clear()
			location.href = '/'
			break
	}
}

export default axios

// 封装post请求(requestUrl：域名公共部分,params：参数列表 type:token类型 ctype:上传数据格式类型)
export function POST(requestUrl, params = '', post, type, ctype) {
	//请求方式
	let method = post ? post : 'post'

	//默认登录token
	let token = getToken();
	//post请求
	if (method == 'post') {
		//设置Content-Type
		if (ctype == 1) {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'Content-Type': ctype,
					'appCode': appCode,
				}
			})
		} else if (ctype == 2) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'appCode': appCode,
				}
			})
		} else if (ctype == 4) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'Content-Type': 'multipart/form-data',
					'appCode': appCode,
				}
			})
		} else if (ctype == 3) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				// 返回文件流blob
				responseType: 'blob',
				headers: {
					'token': token,
					'appCode': appCode,
				}
			})
		} else {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'appCode': appCode,
				}
			})
		}

	} else if (method == 'get') {
		//get请求
		return axios({
			url: requestUrl,
			method: method,
			params: params,
			headers: {
				'token': token,
				'appCode': appCode,
			}
		})
	} else {
		//delete请求
		return axios({
			url: requestUrl,
			method: method,
			params: params,
			headers: {
				'token': token,
				'appCode': appCode,
			}
		})
	}
}
export function down(url, method, data) {
	let Loading;
	Loading = ElementUI.Loading.service({
		fullscreen:true,
		text:'数据处理中，请稍后！！！'
	})
	//默认登录token
	let token = getToken();
	if (method == 'get') {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);        // 也可以使用POST方式，根据接口
		xhr.responseType = "blob";    // 返回类型blob
		xhr.setRequestHeader("token", token);
		// 发送ajax请求
		xhr.send()
		xhr.onload = function () {
			// 请求完成
			if (this.status == 201) {
				// 返回201
				var blob = this.response;
				var reader = new FileReader();
				reader.readAsDataURL(blob);    // 转换为base64，可以直接放入a标签href
				reader.onload = function (e) {
					// 转换完成，创建一个a标签用于下载
					var a = document.createElement('a');
					a.download = data + '.xlsx';
					a.href = e.target.result;
					// 修复firefox中无法触发click
					a.click();
				}
				Loading.close()
			}
		};

	}
}

export function getToken() {
  let token = window.localStorage.getItem('token')
  // 修改部署
  // return token != null ? token : ''
  return token != null ? token : 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIiLCJhdWQiOiIiLCJqdGkiOiI1MTgiLCJpc3MiOiJ3ZWxhaWVkdS5jbiIsImlhdCI6MTcwMDMwMzUzNiwiZXhwIjoxNzAyODk1NTM2LCJyb2xlIjoic2Nob29sIiwic3RhbXAiOjE3MDAzMDM1MzY5NDYsInNjb3BlIjoidG9rZW4ifQ.L9IlpHVnpe2NB9Lw5FDQMKFNELthnaFTOVFySSJrOY4'
}



// WEBPACK FOOTER //
// ./src/api/index.js